import { Component, OnInit } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';

import { IconSetService } from '@coreui/icons-angular';
import { iconSubset } from './icons/icon-subset';
import { Title } from '@angular/platform-browser';
import { TranslationService } from 'src/app/services/translation.service';
import { environment } from '../environments/environment';


@Component({
  selector: 'app-root',
  template: '<router-outlet></router-outlet>',
})
export class AppComponent implements OnInit {
  title = 'Admin Portal';

  constructor(
    private router: Router,
    private titleService: Title,
    private iconSetService: IconSetService,
    private translationService: TranslationService    
  ) {
    titleService.setTitle(this.title);
    // iconSet singleton
    iconSetService.icons = { ...iconSubset };
  }

  ngOnInit(): void {
    this.router.events.subscribe((evt) => {
      if (!(evt instanceof NavigationEnd)) {
        return;
      }
    });
    this.translationService.initializePlaceholders().subscribe((placeholderTexts) => {
      if (placeholderTexts) {
        environment.placeholders = placeholderTexts;
      }
    });    
  }
}
